module.exports = __webpack_public_path__ + "static/media/studio 2 main area seating waiting art wide shot.1280x793.c160bbe2.webp";